import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import './EventScannerNav.scss';

const EventScannerNav: React.FC = () => {
  const { eventSlug } = useParams<{ eventSlug: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  if (!eventSlug) return null;

  const isActive = (route: 'qr' | 'stats' | 'attendees') => {
    const currentPath = location.pathname;
    const normalizedPath = currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath;
    
    // Check exact route match
    if (route === 'qr') {
      return normalizedPath === `/scanner/event/${eventSlug}/qr`;
    }
    if (route === 'stats') {
      return normalizedPath === `/scanner/event/${eventSlug}/stats`;
    }
    if (route === 'attendees') {
      return normalizedPath === `/scanner/event/${eventSlug}/attendees`;
    }
    return false;
  };

  const handleNavigate = (route: 'qr' | 'stats' | 'attendees') => {
    const paths = {
      qr: `/scanner/event/${eventSlug}/qr/`,
      stats: `/scanner/event/${eventSlug}/stats/`,
      attendees: `/scanner/event/${eventSlug}/attendees/`,
    };
    navigate(paths[route]);
  };

  return (
    <footer className="event-scanner-footer">
      <div className="btn-nav-container">
        <button
          type="button"
          className={`btn-nav ${isActive('qr') ? 'active' : ''}`}
          onClick={() => handleNavigate('qr')}
          title="Scan"
          aria-label="Scan QR Codes"
        >
          <i className="fas fa-qrcode"></i>
        </button>
        <button
          type="button"
          className={`btn-nav ${isActive('stats') ? 'active' : ''}`}
          onClick={() => handleNavigate('stats')}
          title="Stats"
          aria-label="View Statistics"
        >
          <i className="fas fa-chart-bar"></i>
        </button>
        <button
          type="button"
          className={`btn-nav ${isActive('attendees') ? 'active' : ''}`}
          onClick={() => handleNavigate('attendees')}
          title="Attendees"
          aria-label="View Attendees"
        >
          <i className="fas fa-users"></i>
        </button>
      </div>
    </footer>
  );
};

export default EventScannerNav;

